var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Set-Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "save-floppy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 3.125C11.25 2.77938 11.53 2.5 11.875 2.5C12.22 2.5 12.5 2.77938 12.5 3.125V5.625C12.5 5.97062 12.22 6.25 11.875 6.25C11.53 6.25 11.25 5.97062 11.25 5.625V3.125ZM5.625 7.5H14.375C14.72 7.5 15 7.22062 15 6.875V0H5V6.875C5 7.22062 5.28 7.5 5.625 7.5ZM17.5 0H16.25V7.5C16.25 8.19 15.69 8.75 15 8.75H5C4.31 8.75 3.75 8.19 3.75 7.5V0H2.5C1.11937 0 0 1.11937 0 2.5V17.5C0 18.8806 1.11937 20 2.5 20H17.5C18.8806 20 20 18.8806 20 17.5V2.5C20 1.11937 18.8806 0 17.5 0Z",
    fill: "#7ABADE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.e73b6bbb8a0cdc1764fa56cfe375632f.svg";
export { ForwardRef as ReactComponent };